import React, { Component, PropTypes } from 'react'
import AuteurLivresContainer from './livres/AuteurLivresContainer.jsx'
import AuteurBiblioContainer from './biobiblio/AuteurBiblioContainer.jsx'
import AuteurBioContainer from './biobiblio/AuteurBioContainer.jsx'
import AuteurLiensContainer from './liens/AuteurLiensContainer.jsx'
import { actions } from '../shared/dispatcher/AppDispatcher.js'
import AppDispatcher from '../shared/dispatcher/AppDispatcher.js'
import NotificationSystem from 'react-notification-system';
import createHistory from 'history/lib/createBrowserHistory';

const Navigation = ( {activeItem, routeChange} ) => {
    return (
        <div className="row">
            <ul className="nav nav-pills" style={{'marginBottom' : 20}} >
                <li role="navigation" className={activeItem == 1 ? "active" : ""}><a onClick={routeChange.bind(null,'livres')} href="livres">Livres</a></li>
                <li role="navigation" className={activeItem == 2 ? "active" : ""}><a onClick={routeChange.bind(null,'bio')} href="bio">Biographie</a></li>
                <li role="navigation" className={activeItem == 3 ? "active" : ""}><a onClick={routeChange.bind(null,'biblio')} href="biblio">Bibliographie</a></li>
                <li role="navigation" className={activeItem == 4 ? "active" : ""}><a onClick={routeChange.bind(null,'liens')} href="liens">Les liens</a></li>
            </ul>
        </div>             
    )
}

class Auteur extends Component{
    
    constructor(props){
        super(props);
        let route ;
        if (typeof window !== 'undefined'){
            route = window.location.pathname.substr(window.location.pathname.lastIndexOf('/') + 1);
            if (route !== 'bio' && route !== 'biblio' && route !== 'liens'){
                route = 'livres';
            }
        } else {
            route = this.props.route; // if server rendered
        }
        this.state={'route': route, 
            'date1' : this.props.date1 || '', 
            'date2' : this.props.date2 || '', 
            'editDates' : false
        };
        this.routeChange = this.routeChange.bind(this);
        this.toggleEditDates = this.toggleEditDates.bind(this);
        this.stopEditDates = this.stopEditDates.bind(this);
        this.saveDates = this.saveDates.bind(this);
        this.changeDate1 = this.changeDate1.bind(this);
        this.changeDate2 = this.changeDate2.bind(this);
        this._notificationSystem = null;
    }

    componentDidMount() {
        

        /*
        window.addEventListener('hashchange', () => {
            console.log('hashchange occured, %s', window.location.hash);
            this.setState({
                route: window.location.hash.substr(1)
            })
        })
        */
        this.history = createHistory({basename: '/i.php/vauteur/' + this.props.aid});

        this._notificationSystem = this.refs.notificationSystem;
        AppDispatcher.on(actions.notifMsg, (msg)=>{
            this._notificationSystem.addNotification({
              message: msg.message,
              title : msg.title || 'Information',
              level: msg.level || 'error'
            });
        });
    }

    routeChange(route,evt){
        evt.preventDefault();
        //console.log(this.history.location);
        this.history.push('/i.php/vauteur/' + this.props.aid + '/' + route);
        this.setState({route: route});
    }

    toggleEditDates(evt){
        evt.preventDefault();
        evt.target.blur();
        
        if (! this.state.editDates){
            //console.log('lets focus');
            setTimeout(()=>{
                this._date1.focus();
            }, 50);
        }
        this.setState({'editDates': ! this.state.editDates, 'date1' : this.props.date1, 'date2' : this.props.date2});
    }

    stopEditDates(evt){
        evt.preventDefault();
        this.setState({'editDates': false, 'date1': this.props.date1, 'date2': this.props.date2});
    }

    changeDate1(){
        if (! Number.isInteger(+this._date1.value)){
            return;
        }
        this.setState({'date1' : this._date1.value});
    }

    changeDate2(){
        this.setState({'date2' : this._date2.value});
    }

    saveDates(evt){
        evt.preventDefault();
        let thisYear = new Date().getFullYear();

        if (this.state.date1 > thisYear || this.state.date2 > thisYear){
            alert('Date invalide, maximum %d', thisYear);
            return;
        }
        if (! Number.isInteger(+this.state.date1)){
            alert('Le date de naissance doit être encodée sous forme de l\'année en 4 positions, par exemple 1965');
            return;
        }
        if (! Number.isInteger(+this.state.date2)){
            alert('Le date de décès doit être encodée sous forme de l\'année en 4 positions, par exemple 2010');
            return;
        }
        if (this.state.date2){
            if (+this.state.date2 < +this.state.date1){
                alert('La date de décès est plus petite que la date de naissance');
                return;
            }
        }
        //console.log('save dates %d et %d pour %d', +this.state.date1,+this.state.date2,aid);
        this.props.saveDates(aid,+this.state.date1,this.state.date2 ? +this.state.date2 : null)
            .then(()=>{
                AppDispatcher.emit(actions.notifMsg,{'message': 'Les dates ont été changées. Merci !', 
                    'level' : 'success', 'title':'Mise à jours'});
                this.setState({'editDates': false}); 
            })
            .fail((error)=>{
                AppDispatcher.emit(actions.notifMsg,{'message': error || 'Erreur imprévue', 
                    'level' : 'error', 'title':'Mise à jours'});
            });
    }

    render(){

        let Children;
        let active = 1;
        switch (this.state.route){
            case 'livres': Children = <AuteurLivresContainer />; active=1;break;
            case 'bio': Children = <AuteurBioContainer />; active=2;break;
            case 'biblio': Children = <AuteurBiblioContainer />; active=3;break;
            case 'liens': Children = <AuteurLiensContainer />; active=4;break;
            default : Children = <AuteurLivresContainer />; 
        }
        let classForm = "form form-inline";
        if (! this.state.editDates){
            classForm += " hidden";
        }
        let datesform = (
                <form className={classForm} style={{'margin': '10px'}} >
                    <label className="control-label" htmlFor="data1" style={{'marginRight': '5px'}} >Année Naissance:</label>
                    <input className="form-control input-sm" ref={(el)=>this._date1=el}
                        style={{maxWidth: 80}}
                        name="date1" onChange={this.changeDate1} value={this.state.date1} /> 
                    {' - '}
                    <label htmlFor="data2" style={{'marginRight': '5px'}}>Année décès:</label>
                    <input className="form-control input-sm" ref={(el)=>this._date2=el}
                        style={{maxWidth: 80}}
                        name="date1" onChange={this.changeDate2} value={this.state.date2} /> 
                    {' '}
                    <button className="btn btn-primary" onClick={this.saveDates}>Sauver</button>
                    {' '}
                    <button className="btn btn-default" onClick={this.stopEditDates}>Annuler</button>
                </form>
            );
        let dates = (
                <span>
                ({this.props.date1 == 0 ? '' : this.props.date1} - {this.props.date2 == 0 ? '' : this.props.date2}) 
                    {this.props.loginok ? <button className="btn btn-link" onClick={this.toggleEditDates}>changer</button> : ''}
                </span>
            );

        return (
            <div>
                <h3>{this.props.auteur1} {dates}</h3>
                {datesform}
                {this.props.auteur2  ? 
                    <p>Translitération Bnf : {this.props.auteur2}</p> : ''
                }
                <Navigation activeItem={active} routeChange={this.routeChange} />
                {Children}
                <NotificationSystem ref="notificationSystem" />
            </div>
        )
    }
}

export default Auteur



// WEBPACK FOOTER //
// ./auteur/Auteur.jsx